<yc-modal
  [modalHeader]="title"
  [primaryButtonText]="!unansweredQuestionsOnly ? ('common:btnSave' | ycI18n: 'Save') : ('common:btnContinue' | ycI18n: 'Continue')"
  (onPrimaryClick)="!unansweredQuestionsOnly ? _goBack() : _signIn()"
  [cancelButtonText]="!unansweredQuestionsOnly ? ('common:btnClose' | ycI18n: 'Close') : ('common:btnRemindMeLater' | ycI18n: 'Remind me later')"
  (onCancel)="!unansweredQuestionsOnly ? _goBack() : _signIn()"
  [primaryDisabled]="primaryDisabled"
  [primaryButtonId]="'primaryBtn'"
  [helpLink]="helpLink">

  <yc-persona-question-and-answers
  [personaQuestionAndAnswerType]="personaQuestionAndAnswerType"
  [nonprofitId]="nonprofitId"
  [nonprofitName]="nonprofitName"
  [unansweredQuestionsOnly]="unansweredQuestionsOnly"
  (addEditModalButtonDisabled)="setPrimaryDisabled($event)"
  [newUserForUnansweredQuestions]="newUser"></yc-persona-question-and-answers>

</yc-modal>